<span class="op-primary-sidebar-toggle-icon"></span>
